import moment from "moment";
import { getWeekdays } from "PFCore/helpers/date";
import { useTranslation } from "react-i18next";

export const useWeekdayLabel = () => {
  const { t } = useTranslation();
  const occurenceLabels = [
    t("order.first"),
    t("order.second"),
    t("order.third"),
    t("order.fourth"),
    t("order.fifth")
  ];

  const currentWeekday = moment().day();
  const currentMonthDates = Array.from({ length: moment().daysInMonth() }, (_, i) =>
    moment().startOf("month").add(i, "days")
  );

  const onlySameWeekdays = currentMonthDates.filter((date) => date.day() === currentWeekday);
  const occurenceOfCurrentWeekday = onlySameWeekdays.findIndex(
    (date) => date.format("DD") === moment().format("DD")
  );

  return `${occurenceLabels[occurenceOfCurrentWeekday]} ${getWeekdays()[currentWeekday - 1]}`;
};
